var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-tabs',{attrs:{"currentPage":'404 Not Found'}}),_c('h1',[_vm._v("404 - Page Not Found")]),_c('p',[_vm._v("The page you are looking for does not exist.")]),_c('div',[_c('router-link',{attrs:{"to":'/'}},[_vm._v("Take me back to the main page")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }